import React from 'react'

import { PageHeader } from '@/components/headers/PageHeader'

import { TableSection } from './sections/TableSection'
import { FiltersSection } from './sections/FiltersSection'

export const ExportsDashboard = () => {
  return (
    <div data-testid="scorecard-exports-dashboard">
      <PageHeader
        title="Advanced Exports"
        description="Use the filters and display options to build, preview, and download a report."
      />
      <FiltersSection />
      <TableSection />
    </div>
  )
}

export default ExportsDashboard
